// @flow

import * as React from 'react';
import type { Node } from 'react';
import { useEffect } from 'react';
import Basic from 'layouts/Basic';
import Title from 'components/Title';
import HowItWorksSteps from 'components/HowItWorksSteps';

import './style.scss';

import { ReactComponent as ServerWomen } from 'assets/svg/server-colour.svg';

export default function HowItWorks(): Node {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production')
      window.analytics.page('How it works');
  }, []);

  return (
    <Basic
      title="Couple words about how it works"
      ilustration={<ServerWomen />}
    >
      <div className="HowItWorks__steps">
        <Title tag="h2" fontSize="m">
          How it works?
        </Title>
        <HowItWorksSteps />
      </div>
      <div>
        <Title tag="h2" fontSize="m">
          Which issues do we fetch?
        </Title>
        <p>We fetch from Github.com only issues that:</p>
        <ul className="main-list">
          <li>are open</li>
          <li>have at least one of the &#39;newcomers welcoming&#39; label</li>
          <li>dont&#39;t have linked pull request</li>
          <li>no one is assigned to them</li>
          <li>conversation is unlocked</li>
          <li>are in public repos</li>
        </ul>
      </div>
    </Basic>
  );
}
